import { useState } from 'react';

function useCopyToClipboard() {
  const [copiedText, setCopiedText] = useState(null);

  const copy = async (text, callback) => {
    if (!navigator.clipboard) {
      return false;
    }

    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      if (callback) {
        callback();
      }
      return true;
    } catch (error) {
      setCopiedText(null);
      return false;
    }
  };

  return [copiedText, copy];
}

export { useCopyToClipboard };
